import { useTranslation } from 'react-i18next'

import { HeroCourt } from '../../../components/ui/courtSvg/CourtSvg'

type StaticHomeHeroCourtProps = {
  eyebrow: string
  callLabel: string
  callHref: string
}

export const StaticHomeHeroCourt = ({
  eyebrow,
  callLabel,
  callHref,
}: StaticHomeHeroCourtProps) => {
  const { t } = useTranslation('home')

  return (
    <div className="hero-court">
      <div className="ph-row ph-between hero-court-header">
        <span className="eyebrow hero-court-eyebrow">{eyebrow}</span>
        <span className="badge badge-accent">
          {t('hero.visual.badge.open')}
        </span>
      </div>

      <div className="hero-court-graphic">
        <HeroCourt />
      </div>

      <div className="ph-row ph-between hero-court-footer">
        <div className="hero-court-cta">
          <div className="mono hero-court-label">
            {t('hero.visual.bookingsUntilLaunch')}
          </div>
          <span className="display hero-court-value">
            {t('hero.visual.byPhone')}
          </span>
        </div>

        <div className="hero-court-meta-end">
          <div className="mono hero-court-label">
            {t('hero.visual.call')}
          </div>
          <a href={callHref} className="hero-court-slots-link">
            <span className="display hero-court-value">{callLabel}</span>
          </a>
        </div>
      </div>
    </div>
  )
}
